class StickyATCPanel extends HTMLElement {
  constructor() {
    super();
    this.priceObserver = null;
    this.priceCheckInterval = null;
  }

  connectedCallback() {
    requestAnimationFrame(() => this.init());
  }

  init() {
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!productForm) {
      console.warn('StickyATCPanel: Product form not found.');
      return;
    }

    const submitButton = productForm.querySelector('button[type="submit"]');
    if (!submitButton) {
      console.warn('StickyATCPanel: Submit button not found.');
      return;
    }

    const stickyButtons = this.querySelectorAll('.product-form__submit');
    if (stickyButtons.length === 0) {
      console.warn('StickyATCPanel: No sticky buttons found inside panel.');
      return;
    }

    stickyButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        submitButton.click();
      });
    });

    this.startPriceSync();
  }

  startPriceSync() {
    const stickyPrice = this.querySelector('.price-item.price-item--regular');
    if (!stickyPrice) {
      console.warn('StickyATCPanel: Sticky price element not found.');
      return;
    }

    let lastPrice = '';

    // Check every 200ms for changes in the main price
    this.priceCheckInterval = setInterval(() => {
      const mainPriceEl = document.querySelector('.price-item.price-item--sale');
      if (mainPriceEl) {
        const currentPrice = mainPriceEl.textContent.trim();
        if (currentPrice !== lastPrice) {
          lastPrice = currentPrice;
          stickyPrice.textContent = currentPrice;
        }
      }
    }, 200);
  }

  disconnectedCallback() {
    if (this.priceObserver) {
      this.priceObserver.disconnect();
    }
    if (this.priceCheckInterval) {
      clearInterval(this.priceCheckInterval);
    }
  }
}

customElements.define('sticky-atc-panel', StickyATCPanel);
